import { MILLISECONDS_IN_SECOND } from "../../unit-utils";
import { convertToSeconds } from "./convert-to-seconds";
import { ISO8601TimeDuration } from "./models";

export function getFinishDate(referenceDate: Date, duration: ISO8601TimeDuration): Date {
    const seconds = convertToSeconds(duration) ?? 0;

    return new Date(referenceDate.getTime() + seconds * MILLISECONDS_IN_SECOND);
}
